/* istanbul ignore file */
export * from './shared-sky-components.module';
export { SkyHeaderComponent } from './sky-header/sky-header.component';
